export const TABLE_HEADER_CLASS = 'table-header title-col large-header formatter-cell division-bottom-only';

export const headerClass = `${TABLE_HEADER_CLASS} text-center fund-header`;
export const subtitleClass = `${TABLE_HEADER_CLASS} text-right fund-header`;
export const headerClassRight = `${TABLE_HEADER_CLASS} text-right division-bottom-only`;
export const contentClass = 'text-right';
export const totalClass = 'title-col subtitle cell show-tooltip';
export const totalClassAlignRight = `${totalClass} ${contentClass}`;
// +1 for javascript arrays starting at 0, +2 for the 2 title rows
export const OFFSET_TO_STARTING_ROW = 3;
export const FIRM_TOTALS_LABEL = 'Firm Totals';
export const TOTAL_LABEL = 'Total';
export const EXIT_DATE_ALIAS = 'exit_date';
export const EXIT_EQUITY_ALIAS = 'exit_equity_value';
export const EXIT_ENTERPRISE_VALUE_ALIAS = 'exit_enterprise_value';
export const PLUS_CASH_ALIAS = 'plus_cash';
export const LESS_DEBT_ALIAS = 'less_debt';
export const FOREIGN_PLUS_CASH_ALIAS = 'foreign_plus_cash';
export const FOREIGN_LESS_DEBT_ALIAS = 'foreign_less_debt';
export const FOREIGN_EXCHANGE_RATE_BASE_ALIAS = 'foreign_exchange_rate_base';
export const FOREIGN_EXCHANGE_RATE_TARGET_ALIAS = 'foreign_exchange_rate_target';
export const CAP_TABLE_ALIAS = 'cap_table';
export const MEASUREMENT_DATE_ALIAS = 'measurementDateId';
export const COMPANY_ALIAS = 'companyId';
export const FIRM_TOTAL_EXIT_PROCEEDS_ALIAS = 'firm_total_exit_proceeds';
